import { Splide } from '@splidejs/splide';

const partnerSlider = {
    init(partnerSlider) {
        /* Accountant has 4 slides, while bexio has 5 slides.
         * So we need to calculate the number of slides and set the perPage value accordingly.
         */
        const partnerSliderSelector = '#partner-slider';
        const sliderElement = document.querySelector(partnerSliderSelector);
        if (!sliderElement) {
            console.error("Slider element not found with the following selector:", partnerSliderSelector);
            return;
        }
        const slides = sliderElement.querySelectorAll('.splide__slide');
        const totalSlides = slides.length;

        new Splide(partnerSlider, {
            type: 'loop',
            padding: '10%',
            lazyLoad: true,
            keyboard: false,
            perPage: totalSlides > 5 ? 5 : totalSlides,
            arrows: false,
            gap: '2rem',
            destroy: true,
            breakpoints: {
                639: {
                    perPage: 2,
                    destroy: false,
                },
                767: {
                    perPage: 2,
                    destroy: false,
                },
                1023: {
                    perPage: 3,
                    destroy: false,
                },
            },
        }).mount();
    },
};

export { partnerSlider as default };
